import { render } from "./BotaoFaleConosco.vue?vue&type=template&id=1f6af091&scoped=true"
import script from "./BotaoFaleConosco.vue?vue&type=script&lang=js"
export * from "./BotaoFaleConosco.vue?vue&type=script&lang=js"

import "./BotaoFaleConosco.vue?vue&type=style&index=0&id=1f6af091&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6af091"]])

export default __exports__